"use client";

import { c as _c } from "react/compiler-runtime";
import { type TextFieldProps } from "@mui/material";
import Joi from "joi";
import React, { useState } from "react";
import { useI18nContext } from "#/shared/hooks";
import { DebouncedInput } from "#/shared/ui/molecules/DebouncedInput";
type JsonInputProps = Omit<TextFieldProps, "onChange"> & {
  value: string;
  onChange: (value: string) => void;
  validationSchema: Joi.Schema;
  /** Debounce for persisting JSON text (passed to `DebouncedInput`). */
  timeout?: number;
  /** Rendered in `slotProps.input.endAdornment` before any inherited adornment (e.g. rename control). */
  suffixSlot?: React.ReactNode;
};
export const JsonInput: React.FC<JsonInputProps> = t0 => {
  const $ = _c(31);
  let onChange;
  let restProps;
  let slotProps;
  let suffixSlot;
  let timeout;
  let validationSchema;
  if ($[0] !== t0) {
    ({
      onChange,
      validationSchema,
      timeout,
      suffixSlot,
      slotProps,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = onChange;
    $[2] = restProps;
    $[3] = slotProps;
    $[4] = suffixSlot;
    $[5] = timeout;
    $[6] = validationSchema;
  } else {
    onChange = $[1];
    restProps = $[2];
    slotProps = $[3];
    suffixSlot = $[4];
    timeout = $[5];
    validationSchema = $[6];
  }
  const {
    LL
  } = useI18nContext();
  const [inputError, setInputError] = useState(null);
  let t1;
  if ($[7] !== onChange || $[8] !== validationSchema) {
    t1 = value => {
      onChange(value);
      if (!value) {
        setInputError(null);
      }
      ;
      try {
        const parsed = JSON.parse(value);
        Joi.assert(parsed, validationSchema);
        setInputError(null);
      } catch (t2) {
        const error = t2;
        if (error instanceof Error) {
          setInputError(error.message);
        } else {
          setInputError("Unknown error");
          console.error(error);
        }
      }
    };
    $[7] = onChange;
    $[8] = validationSchema;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const handleChange = t1;
  const inputSlotProps = slotProps?.input;
  const inheritedEndAdornment = typeof inputSlotProps === "object" && inputSlotProps !== null && "endAdornment" in inputSlotProps ? inputSlotProps.endAdornment : null;
  let t2;
  if ($[10] !== LL) {
    t2 = LL.INPUT();
    $[10] = LL;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = !!inputError;
  let t4;
  if ($[12] !== inputSlotProps) {
    t4 = typeof inputSlotProps === "object" && inputSlotProps !== null ? inputSlotProps : {};
    $[12] = inputSlotProps;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== inheritedEndAdornment || $[15] !== suffixSlot) {
    t5 = <>{suffixSlot}{inheritedEndAdornment}</>;
    $[14] = inheritedEndAdornment;
    $[15] = suffixSlot;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = {
      ...t4,
      endAdornment: t5
    };
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== slotProps || $[21] !== t6) {
    t7 = {
      ...slotProps,
      input: t6
    };
    $[20] = slotProps;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== handleChange || $[24] !== inputError || $[25] !== restProps || $[26] !== t2 || $[27] !== t3 || $[28] !== t7 || $[29] !== timeout) {
    t8 = <DebouncedInput label={t2} placeholder="e.g.: [1,2,3,null,5]" onChange={handleChange} error={t3} helperText={inputError} fullWidth={true} timeout={timeout} slotProps={t7} {...restProps} />;
    $[23] = handleChange;
    $[24] = inputError;
    $[25] = restProps;
    $[26] = t2;
    $[27] = t3;
    $[28] = t7;
    $[29] = timeout;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};